import React from 'react';
import { Link } from 'react-router-dom';
import AppStoreBadge from './AppStoreBadge';

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="container footer-grid">
        <div className="footer-brand">
          <h3>Recalls365</h3>
          <p>Stay ahead of recalls with clear, practical guidance and alerts that fit your life.</p>
          <AppStoreBadge className="footer-badge" />
        </div>
        <div className="footer-links">
          <h4>Explore</h4>
          <ul>
            <li><Link to="/blog">Blog</Link></li>
            <li><Link to="/guides">Guides</Link></li>
            <li><Link to="/latest-recalls">Latest Recalls</Link></li>
            <li><Link to="/about">About</Link></li>
          </ul>
        </div>
        <div className="footer-links">
          <h4>Support</h4>
          <ul>
            <li><Link to="/contact">Contact</Link></li>
            <li><Link to="/reset-password">Reset Password</Link></li>
            <li><a href="mailto:support@recalls365.com">support@recalls365.com</a></li>
          </ul>
        </div>
        <div className="footer-links">
          <h4>Legal</h4>
          <ul>
            <li><Link to="/privacy">Privacy</Link></li>
            <li><Link to="/terms">Terms</Link></li>
            <li><Link to="/disclaimer">Disclaimer</Link></li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <p>(c) {new Date().getFullYear()} Recalls365. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
